import * as React from "react";
export default React.memo(function SvgAverage(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" role="presentation" {...props}><path d="m4 8.39 2 2.09 2.39-2.72 2.69 2.75 4.7-5.89-1.56-1.24-3.3 4.11-2.63-2.68L6 7.52l-1.91-2-3.8 3.77 1.42 1.42ZM0 12.3v1.4h16v-1.4Z" /></svg>;
});